<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({ modelValue: { type: String, default: 'create' } });
const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const endpoints = [
  {
    id: 'create',
    method: 'POST',
    label: t('PAINEL.API_PLAYGROUND.ENDPOINT.CREATE'),
  },
  {
    id: 'list',
    method: 'GET',
    label: t('PAINEL.API_PLAYGROUND.ENDPOINT.LIST'),
  },
  {
    id: 'list_upcoming',
    method: 'GET',
    label: t('PAINEL.API_PLAYGROUND.ENDPOINT.LIST_UPCOMING'),
  },
  {
    id: 'confirm',
    method: 'POST',
    label: t('PAINEL.API_PLAYGROUND.ENDPOINT.CONFIRM'),
  },
  {
    id: 'update',
    method: 'PATCH',
    label: t('PAINEL.API_PLAYGROUND.ENDPOINT.UPDATE'),
  },
  {
    id: 'destroy',
    method: 'DELETE',
    label: t('PAINEL.API_PLAYGROUND.ENDPOINT.DESTROY'),
  },
  {
    id: 'create_human_attention',
    method: 'POST',
    label: t('PAINEL.API_PLAYGROUND.ENDPOINT.CREATE_HUMAN_ATTENTION'),
  },
  {
    id: 'mark_read_by_phone',
    method: 'POST',
    label: t('PAINEL.API_PLAYGROUND.ENDPOINT.MARK_READ_BY_PHONE'),
  },
];
</script>

<template>
  <div class="flex flex-col gap-2">
    <label
      v-for="ep in endpoints"
      :key="ep.id"
      class="flex cursor-pointer items-center gap-2"
    >
      <input
        type="radio"
        :value="ep.id"
        :checked="props.modelValue === ep.id"
        @change="emit('update:modelValue', ep.id)"
      />
      <span class="font-mono text-xs text-n-slate-10">{{ ep.method }}</span>
      <span>{{ ep.label }}</span>
    </label>
  </div>
</template>
